"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("@mui/material"),e=require("@mui/material/styles"),l=e.styled("div")`
  height: 56px;
`,p=e.styled("div")`
  display: flex;
  align-items: center;
  padding: 18px 16px;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
`,i=e.styled(t.Select)`
  ${`.${t.selectClasses.filled}:focus`} {
    background-color: transparent;
  }
`,s=e.styled("div")`
  display: flex;
  justify-content: space-between;
  width: 100%;
`,o=e.styled("div")`
  display: block;
  white-space: normal;

  & > div,
  button {
    margin-right: 4px;
    margin-bottom: 4px;
  }
`,n=e.styled(t.InputLabel)`
  font-family: 'Lato';
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.5px;
`,r=e.styled(t.FormHelperText)`
  font-family: 'Lato';
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
`;exports.ChipsStack=o;exports.SkeletonDetailsWrapper=p;exports.SkeletonWrapper=l;exports.StyledFormHelperText=r;exports.StyledInputLabel=n;exports.StyledSelect=i;exports.ToggleWrapper=s;
